import React, { useEffect, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/theme-xcode'
import SydButton from '../../../../../../commonDesign/Button'
import Icon from '../../../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: 'var(--border-radius-lg)',
    width: '88vw',
    maxWidth: '1100px',
    height: '85vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 24px 48px rgba(0,0,0,0.2)',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    borderBottom: '1px solid var(--color-neutral-200)',
    flexShrink: 0
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  headerTitle: {
    fontSize: '16px',
    fontWeight: 700,
    color: 'var(--color-neutral-900)'
  },
  badge: {
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  addBadge: {
    backgroundColor: 'var(--color-success-100)',
    color: 'var(--color-success-700)'
  },
  updateBadge: {
    backgroundColor: 'var(--color-ai-100)',
    color: 'var(--color-ai-700)'
  },
  removeBadge: {
    backgroundColor: 'var(--color-danger-100)',
    color: 'var(--color-danger-700)'
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: 'var(--color-neutral-400)',
    padding: '4px',
    '&:hover': {
      color: 'var(--color-neutral-600)'
    }
  },
  body: {
    flex: 1,
    overflow: 'auto',
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  sectionLabel: {
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: 'var(--color-neutral-400)'
  },
  sideBySide: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  paneLabel: {
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    marginBottom: '4px'
  },
  paneLabelOld: {
    color: 'var(--color-danger-600)'
  },
  paneLabelNew: {
    color: 'var(--color-success-600)'
  },
  valueBox: {
    padding: '8px 10px',
    borderRadius: '6px',
    fontSize: '13px',
    fontFamily: 'inherit',
    border: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    minHeight: '32px',
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word'
  },
  valueBoxRemoved: {
    backgroundColor: 'rgba(239, 68, 68, 0.08)',
    borderColor: 'var(--color-danger-200)',
    textDecoration: 'line-through',
    color: 'var(--color-danger-600)'
  },
  valueBoxAdded: {
    backgroundColor: 'rgba(34, 197, 94, 0.08)',
    borderColor: 'var(--color-success-300)'
  },
  modeBadge: {
    padding: '3px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 600,
    display: 'inline-block'
  },
  editorWrapper: {
    borderRadius: '6px',
    overflow: 'hidden',
    border: '1px solid var(--color-neutral-200)'
  },
  editorWrapperRemoved: {
    border: '1px solid var(--color-danger-200)',
    backgroundColor: 'rgba(239, 68, 68, 0.04)'
  },
  editorWrapperAdded: {
    border: '1px solid var(--color-success-300)',
    backgroundColor: 'rgba(34, 197, 94, 0.04)'
  },
  emptyEditor: {
    padding: '12px',
    fontSize: '12px',
    color: 'var(--color-neutral-400)',
    fontStyle: 'italic',
    backgroundColor: 'var(--color-neutral-050)',
    borderRadius: '6px',
    border: '1px solid var(--color-neutral-200)',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center'
  },
  changeIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '10px',
    fontWeight: 600,
    marginLeft: '8px',
    padding: '1px 6px',
    borderRadius: '3px'
  },
  changedTag: {
    backgroundColor: 'var(--color-ai-100)',
    color: 'var(--color-ai-700)'
  },
  addedTag: {
    backgroundColor: 'var(--color-success-100)',
    color: 'var(--color-success-700)'
  },
  unchangedTag: {
    backgroundColor: 'var(--color-neutral-100)',
    color: 'var(--color-neutral-500)'
  },
  removeNotice: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: 'var(--color-danger-050)',
    border: '1px solid var(--color-danger-200)',
    color: 'var(--color-danger-700)',
    fontSize: '13px'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid var(--color-neutral-200)',
    flexShrink: 0,
    gap: '8px'
  }
}))

function normalizeProposedInput (testArgs) {
  if (!testArgs.variables) return '{}'
  if (typeof testArgs.variables === 'string') return testArgs.variables
  return JSON.stringify(testArgs.variables, null, 2)
}

function normalizeProposedMocks (testArgs) {
  if (!testArgs.mocks?.responses || testArgs.mocks.responses.length === 0) return '[]'
  return JSON.stringify(testArgs.mocks.responses, null, 2)
}

function getProposedMode (testArgs) {
  if (testArgs.mocks?.strategy === 'throwOnMiss') return 'unit'
  return 'integration'
}

function getModeStyle (mode) {
  if (mode === 'integration') return { backgroundColor: 'var(--color-warning-050)', color: 'var(--color-warning-700)' }
  return { backgroundColor: 'var(--color-primary-050)', color: 'var(--color-primary-700)' }
}

function editorHeight (text) {
  if (!text) return '40px'
  const lines = text.split('\n').length
  return Math.max(40, Math.min(lines * 16 + 12, 200)) + 'px'
}

function SectionEditor ({ value, mode, height }) {
  if (!value || value === '{}' || value === '[]' || value.trim() === '') return null
  return (
    <AceEditor
      mode={mode}
      theme='xcode'
      value={value}
      readOnly
      highlightActiveLine={false}
      showGutter={false}
      showPrintMargin={false}
      width='100%'
      height={height || '80px'}
      fontSize={12}
      tabSize={2}
      wrapEnabled
      editorProps={{ $blockScrolling: true }}
      setOptions={{ useWorker: false, showFoldWidgets: false }}
    />
  )
}

SectionEditor.propTypes = {
  value: PropTypes.string,
  mode: PropTypes.string.isRequired,
  height: PropTypes.string
}

function ChangeTag ({ isNew, oldVal, newVal, classes }) {
  if (isNew) return <span className={`${classes.changeIndicator} ${classes.addedTag}`}>new</span>
  if (oldVal === newVal) return <span className={`${classes.changeIndicator} ${classes.unchangedTag}`}>unchanged</span>
  return <span className={`${classes.changeIndicator} ${classes.changedTag}`}>changed</span>
}

ChangeTag.propTypes = {
  isNew: PropTypes.bool,
  oldVal: PropTypes.string,
  newVal: PropTypes.string,
  classes: PropTypes.object.isRequired
}

function TextDiffSection ({ label, oldVal, newVal, isUpdate, isNew, classes }) {
  const changed = isUpdate && oldVal !== newVal
  return (
    <div className={classes.section}>
      <div className={classes.sectionLabel}>
        {label} <ChangeTag isNew={isNew} oldVal={oldVal} newVal={newVal} classes={classes} />
      </div>
      {isUpdate ? (
        <div className={classes.sideBySide}>
          <div>
            <div className={`${classes.paneLabel} ${classes.paneLabelOld}`}>Current</div>
            <div className={`${classes.valueBox} ${changed ? classes.valueBoxRemoved : ''}`}>
              {oldVal}
            </div>
          </div>
          <div>
            <div className={`${classes.paneLabel} ${classes.paneLabelNew}`}>Proposed</div>
            <div className={`${classes.valueBox} ${changed ? classes.valueBoxAdded : ''}`}>
              {newVal}
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.valueBox}>{newVal}</div>
      )}
    </div>
  )
}

TextDiffSection.propTypes = {
  label: PropTypes.string.isRequired,
  oldVal: PropTypes.string,
  newVal: PropTypes.string,
  isUpdate: PropTypes.bool,
  isNew: PropTypes.bool,
  classes: PropTypes.object.isRequired
}

function isEmptyValue (v) {
  return !v || v === '{}' || v === '[]' || v.trim() === ''
}

function EditorDiffSection ({ label, oldVal, newVal, isUpdate, isNew, mode, emptyLabel, classes }) {
  const changed = isUpdate && oldVal !== newVal

  return (
    <div className={classes.section}>
      <div className={classes.sectionLabel}>
        {label} <ChangeTag isNew={isNew} oldVal={oldVal} newVal={newVal} classes={classes} />
      </div>
      {isUpdate ? (
        <div className={classes.sideBySide}>
          <div>
            <div className={`${classes.paneLabel} ${classes.paneLabelOld}`}>Current</div>
            {!isEmptyValue(oldVal) ? (
              <div className={`${classes.editorWrapper} ${changed ? classes.editorWrapperRemoved : ''}`}>
                <SectionEditor value={oldVal} mode={mode} height={editorHeight(oldVal)} />
              </div>
            ) : <div className={classes.emptyEditor}>{emptyLabel}</div>}
          </div>
          <div>
            <div className={`${classes.paneLabel} ${classes.paneLabelNew}`}>Proposed</div>
            {!isEmptyValue(newVal) ? (
              <div className={`${classes.editorWrapper} ${changed ? classes.editorWrapperAdded : ''}`}>
                <SectionEditor value={newVal} mode={mode} height={editorHeight(newVal)} />
              </div>
            ) : <div className={classes.emptyEditor}>{emptyLabel}</div>}
          </div>
        </div>
      ) : (
        !isEmptyValue(newVal) ? (
          <div className={classes.editorWrapper}>
            <SectionEditor value={newVal} mode={mode} height={editorHeight(newVal)} />
          </div>
        ) : <div className={classes.emptyEditor}>{emptyLabel}</div>
      )}
    </div>
  )
}

EditorDiffSection.propTypes = {
  label: PropTypes.string.isRequired,
  oldVal: PropTypes.string,
  newVal: PropTypes.string,
  isUpdate: PropTypes.bool,
  isNew: PropTypes.bool,
  mode: PropTypes.string.isRequired,
  emptyLabel: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired
}

function TestDiffModal ({ testArgs, existingTest, onApply, onDismiss }) {
  const classes = useStyles()
  const isRemove = !!testArgs.remove
  const isUpdate = !!existingTest && !isRemove

  const proposed = useMemo(() => ({
    name: testArgs.name || '',
    mode: getProposedMode(testArgs),
    input: normalizeProposedInput(testArgs),
    mocks: normalizeProposedMocks(testArgs),
    assertions: testArgs.assertion || testArgs.assertions || ''
  }), [testArgs])

  const current = useMemo(() => {
    if (!existingTest) return null
    return {
      name: existingTest.name || '',
      mode: existingTest.testMode || 'unit',
      input: existingTest.input || '{}',
      mocks: existingTest.responses || '[]',
      assertions: existingTest.assertions || ''
    }
  }, [existingTest])

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onDismiss() }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [onDismiss])

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onDismiss()
  }

  const isNew = !current

  let actionLabel = 'Add Test'
  let badgeLabel = 'New'
  let badgeClass = classes.addBadge
  if (isRemove) {
    actionLabel = 'Remove Test'
    badgeLabel = 'Remove'
    badgeClass = classes.removeBadge
  } else if (isUpdate) {
    actionLabel = 'Apply Changes'
    badgeLabel = 'Update'
    badgeClass = classes.updateBadge
  }

  return (
    <div className={classes.overlay} onClick={handleOverlayClick}>
      <div className={classes.modal}>
        <div className={classes.header}>
          <div className={classes.headerLeft}>
            <span className={classes.headerTitle}>Review Test Changes</span>
            <span className={`${classes.badge} ${badgeClass}`}>{badgeLabel}</span>
          </div>
          <button
            className={classes.closeBtn}
            onClick={onDismiss}
            aria-label='Close test diff modal'
          >
            &times;
          </button>
        </div>

        <div className={classes.body}>
          {isRemove && (
            <div className={classes.removeNotice}>
              <Icon name='warning' customSize='18px' />
              <span>This will remove the test &ldquo;{testArgs.name}&rdquo; from the workspace.</span>
            </div>
          )}

          {!isRemove && (
            <>
              <TextDiffSection
                label='Name'
                oldVal={current?.name}
                newVal={proposed.name || existingTest?.name}
                isUpdate={isUpdate}
                isNew={isNew}
                classes={classes}
              />

              <div className={classes.section}>
                <div className={classes.sectionLabel}>
                  Mode <ChangeTag isNew={isNew} oldVal={current?.mode} newVal={proposed.mode} classes={classes} />
                </div>
                {isUpdate ? (
                  <div className={classes.sideBySide}>
                    <div>
                      <div className={`${classes.paneLabel} ${classes.paneLabelOld}`}>Current</div>
                      <span className={classes.modeBadge} style={getModeStyle(current.mode)}>
                        {current.mode}
                      </span>
                    </div>
                    <div>
                      <div className={`${classes.paneLabel} ${classes.paneLabelNew}`}>Proposed</div>
                      <span className={classes.modeBadge} style={getModeStyle(proposed.mode)}>
                        {proposed.mode}
                      </span>
                    </div>
                  </div>
                ) : (
                  <span className={classes.modeBadge} style={getModeStyle(proposed.mode)}>
                    {proposed.mode}
                  </span>
                )}
              </div>

              <EditorDiffSection
                label='Input'
                oldVal={current?.input}
                newVal={proposed.input}
                isUpdate={isUpdate}
                isNew={isNew}
                mode='json'
                emptyLabel='No input'
                classes={classes}
              />

              <EditorDiffSection
                label='Mock Responses'
                oldVal={current?.mocks}
                newVal={proposed.mocks}
                isUpdate={isUpdate}
                isNew={isNew}
                mode='json'
                emptyLabel='No mock responses'
                classes={classes}
              />

              <EditorDiffSection
                label='Assertions'
                oldVal={current?.assertions}
                newVal={proposed.assertions}
                isUpdate={isUpdate}
                isNew={isNew}
                mode='javascript'
                emptyLabel='No assertions'
                classes={classes}
              />
            </>
          )}

          {isRemove && (
            <TextDiffSection
              label='Name'
              oldVal={existingTest?.name}
              newVal={existingTest?.name}
              isUpdate={false}
              isNew={false}
              classes={classes}
            />
          )}
        </div>

        <div className={classes.footer}>
          <SydButton size='sm' variant='outline' onClick={onDismiss}>
            Dismiss
          </SydButton>
          <SydButton
            size='sm'
            variant={isRemove ? 'outline' : 'ai'}
            onClick={() => onApply(testArgs)}
          >
            {actionLabel}
          </SydButton>
        </div>
      </div>
    </div>
  )
}

TestDiffModal.propTypes = {
  testArgs: PropTypes.object.isRequired,
  existingTest: PropTypes.object,
  onApply: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}

export default TestDiffModal
